import React from 'react'
import styled from 'styled-components'
import { colors } from '~/design'
import MenuIcon from '~/components/icons/ui/24px_menu-34.svg'
import RemoveIcon from '~/components/icons/ui/24px_simple-remove.svg'
import BackIcon from '~/components/icons/arrows/24px_minimal-left.svg'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useViewMode } from '~/prix/react/hooks/viewMode'

const Wrapper = styled.div<{ $isFloating: boolean }>`
  display: none;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    order: 1;

    position: ${({ $isFloating }) => ($isFloating ? 'absolute' : 'relative')};
    z-index: ${({ $isFloating }) => ($isFloating ? 10 : 1)};
    top: ${({ $isFloating }) => ($isFloating ? '0.6rem' : 'auto')};
    left: ${({ $isFloating }) => ($isFloating ? '0.6rem' : 'auto')};
    background-color: ${({ $isFloating }) => ($isFloating ? 'transparent' : 'white')};
    box-shadow: ${({ $isFloating, theme }) => ($isFloating ? 'none' : theme.shadow(1))};
    height: ${({ $isFloating }) => ($isFloating ? '40px' : '60px')};
    overflow: ${({ $isFloating }) => ($isFloating ? 'visible' : 'hidden')};
  }

  nav {
    display: none;

    @media (max-width: 768px) {
      display: flex;
      flex-direction: column;

      span {
        display: none;
      }
      .flex {
        padding: 0px;
        display: flex;
        width: 100%;

        ${({ $isFloating }) =>
          $isFloating &&
          `
            width: auto;
            margin: 0;
            gap: 0.6rem;
            height: 40px;
          `}
      }
      .item {
        display: flex;
        padding: ${({ $isFloating }) => ($isFloating ? '5px 15px' : '10px 5px;')};
        justify-content: center;
        align-items: center;
        text-align: center;
        width: ${({ $isFloating }) => ($isFloating ? '40px' : '20%')};
        background-color: ${({ $isFloating }) => ($isFloating ? 'white' : 'transparent')};
        border-radius: ${({ $isFloating }) => ($isFloating ? '8px' : '0')};
        box-shadow: ${({ $isFloating, theme }) => ($isFloating ? theme.shadow(1) : 'none')};
      }
      .center {
        width: ${({ $isFloating }) => ($isFloating ? 'auto' : '60%')};
      }
      .menu {
        position: fixed;
        top: 0;
        right: 0;
        width: 100%;
        background-color: rgba(95, 39, 205, 0.5);
        backdrop-filter: blur(6px);
        flex: 1;

        ul {
          align-items: center;
          justify-content: flex-start;

          li {
            display: flex;
          }
        }
      }
    }
  }
`

const Button = styled.button`
  display: none;

  background: none;
  border: none;
  cursor: pointer;

  @media (max-width: 768px) {
    display: flex;
    flex-shrink: 1;
    text-align: center;
    flex-direction: column;
    align-items: center;

    .link {
      width: 70%;
      height: 70%;
      align-items: center;
    }
    .icon {
      width: 70%;
      height: 70%;
    }
    svg {
      margin-top: 0px;
    }
  }
`

export default function Head({
  title,
  isVisibleMenu,
  onToggleMenu,
  menu,
  isFloating,
}: {
  title?: string
  isVisibleMenu: boolean
  onToggleMenu: any
  menu: boolean
  isFloating: boolean
}) {
  const navigate = useNavigate()
  const viewMode = useViewMode()

  const [searchParams] = useSearchParams()
  const definedOptionParam = searchParams.get('definedOption')

  return (
    <Wrapper $isFloating={isFloating}>
      <nav className='menu'>
        <ul className='flex'>
          <li className='item'>
            {viewMode === 'normal' && definedOptionParam === null ? (
              <Button className='link icon' onClick={() => navigate(-1)}>
                {isFloating ? (
                  <BackIcon width={20} height={20} fill={'#363636'} />
                ) : (
                  <BackIcon width={24} height={24} fill={colors.sebraeBlue} />
                )}
              </Button>
            ) : null}

            {viewMode === 'normal' && definedOptionParam !== null ? (
              <Button className='link icon' onClick={() => navigate('../map', { replace: true })}>
                <BackIcon width={24} height={24} fill={colors.sebraeBlue} />
              </Button>
            ) : null}
          </li>

          {title ? (
            <li className='item center'>
              <h3> {title} </h3>
            </li>
          ) : null}
          {menu ? (
            <li className='item'>
              <Button className='link icon' onClick={onToggleMenu}>
                {isVisibleMenu ? (
                  <RemoveIcon width={24} height={24} fill={colors.sebraeBlue} />
                ) : (
                  <MenuIcon width={24} height={24} fill={colors.sebraeBlue} />
                )}
              </Button>
            </li>
          ) : null}
        </ul>
      </nav>
    </Wrapper>
  )
}
